import { useIsClient } from '@/hooks/useIsClient/useIsClient';
import styles from './styles.module.scss';
import context from '@/styles/contexts.module.scss';
import Skeleton from '@mui/material/Skeleton';
import classNames from 'classnames';
import { useMemo } from 'react';

export const TablePlaceholder = (props: { rowsCount: number }) => {
  return useMemo(
    () => (
      <div className={styles.placeholder}>
        {Array.from({ length: props.rowsCount + 1 }).map((_, index) => (
          <Skeleton variant="rounded" animation={'wave'} key={index} />
        ))}
      </div>
    ),
    [props.rowsCount],
  );
};

export function WithSkeleton(props: {
  rowsCount: number;
  children: React.ReactNode;
  className?: classNames.Argument | classNames.ArgumentArray;
  loading?: boolean;
}) {
  const { isClient } = useIsClient();
  return (
    <div className={classNames(context.dark, props.className)}>
      {props.loading || !isClient ? <TablePlaceholder rowsCount={props.rowsCount} /> : props.children}
    </div>
  );
}
